import React from "react";
import "./Header.css";
import Head from "./Head";
import Search from "./Search";
import NavL from "./NavL";
import SocialMedia from "../SocialMedia/SocialMedia";
// import Navbar from "./Navbar"

const Header = ({ CartItem }) => {
  return (
    <>
      <Head />
      <Search CartItem={CartItem} />
      {/* <Navbar /> */}
      {/* <NavL /> */}
      <SocialMedia />
    </>
  );
};

export default Header;
